<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { changeDpiDataUrl } from 'changedpi'
import LABELS from '@/constants/labels'
import isMobile from 'ismobilejs'
import {
  roundedImage,
  roundedImageCirle,
  fillStyleBackgroundImage,
} from '@/helpers/site'
import { Document } from 'canvg'

export default {
  name: 'Export',
  data() {
    return {
      dataAvatar: [],
      urlA4Image: '',
      url2LImage: '',
      urlLImage: '',
      exportUrls: {},
    }
  },
  computed: {
    ...mapGetters('settings', ['getOrientation', 'getExportImage']),
    ...mapState('settings', ['modules']),
    mappingLabels() {
      return LABELS
    },
    pathOfWeb() {
      return window.location.origin + window.location.pathname + '#/'
    },
    displayTextTitle() {
      const onMobile = isMobile().any
      return onMobile
        ? {
            titleText:
              'スマートフォンの方は長押しで保存<br>PCの方は右クリックして保存してください',
            modalText: '右クリックして保存してください',
          }
        : {
            titleText:
              'スマートフォンの方は長押しで保存<br>PCの方は右クリックして保存してください',
            modalText: '右クリックして保存してください',
          }
    },
  },
  methods: {
    ...mapActions('settings', [
      'setLayout',
      'setModules',
      'setExport',
      'saveToStorage',
    ]),
    getFirstImage() {
      return new Promise(resolve => {
        const img = new Image()
        img.src = this.getExportImage
        img.onload = () => {
          this.exportUrls = {
            img,
            width: img.width,
            height: img.height,
          }
          resolve()
        }
      })
    },
    resetData() {
      this.setLayout({ reset: true })
      this.setModules({ reset: true })
      this.setExport({ reset: true })
      this.saveToStorage()
    },
    showModalSaveAvatar(urlImg, isCirle) {
      this.$nextTick(() => {
        this.$refs.saveAvatarModal &&
          this.$refs.saveAvatarModal.show({
            title: this.displayTextTitle.modalText,
            textSubmitButton: '閉じる',
            urlImg: urlImg,
            isCirle: isCirle,
          })
      })
    },
    showPrintImageModal(urlImg) {
      this.$nextTick(() => {
        this.$refs.printImageModal &&
          this.$refs.printImageModal.show({
            title: this.displayTextTitle.modalText,
            textSubmitButton: '閉じる',
            urlImg: urlImg,
          })
      })
    },

    checkPaperSize(paperSize = 'L') {
      const orientation = this.getOrientation === 'portraid'
      let cWidth = 1500,
        cHeight = 1051,
        columns = 1,
        rows = orientation ? 1 : 2
      let percentWidth = 0.99
      let percentHeight = 0.99
      let gapImg = 10
      if (paperSize === 'A4') {
        cWidth = 2480
        cHeight = 3508
        columns = orientation ? 7 : 4
        rows = orientation ? 2 : 4
        gapImg = 0
        percentWidth = 1.02
        percentHeight = 1.02
      }

      if (paperSize === '2L') {
        cWidth = 2102
        cHeight = 1500
        columns = orientation ? 3 : 1
        rows = orientation ? 1 : 3
        if (orientation) {
          percentHeight = 0.98
        }
      }

      if (orientation) {
        percentHeight = 0.98
      }

      return {
        cWidth,
        cHeight,
        columns,
        rows,
        percentWidth,
        percentHeight,
        gapImg,
      }
    },

    mathsAlignImage(paperSize, url, heightLogoWarning) {
      if (this.exportUrls) {
        const { img, width: imgWidth, height: imgHeight } = this.exportUrls
        const imgLogoWarning = new Image()
        imgLogoWarning.src = url

        const {
          cWidth,
          cHeight,
          columns,
          rows,
          percentWidth,
          percentHeight,
          gapImg,
        } = this.checkPaperSize(paperSize)

        let c = Document.createCanvas(cHeight, cWidth)
        let ctx = c.getContext('2d')

        return new Promise(resolve => {
          imgLogoWarning.onload = () => {
            const mathImgWidth = imgWidth * percentWidth + gapImg
            const mathImgHeight = imgHeight * percentHeight + gapImg
            let paddingWidth = (cHeight - (columns * mathImgWidth - gapImg)) / 2

            let paddingHeight =
              (cWidth - heightLogoWarning - (rows * mathImgHeight - gapImg)) / 2

            ctx.fillStyle = '#ffffff'
            ctx.fillRect(0, 0, cHeight, cWidth)
            for (let col = 0; col < columns; col++) {
              for (let row = 0; row < rows; row++) {
                ctx.save()
                roundedImage(
                  ctx,
                  col * mathImgWidth + paddingWidth,
                  row * mathImgHeight + paddingHeight,
                  imgWidth * percentWidth,
                  imgHeight * percentHeight,
                  35
                )
                ctx.strokeStyle = '#0073E6'
                ctx.stroke()
                ctx.clip()

                ctx.drawImage(
                  img,
                  col * mathImgWidth + paddingWidth,
                  row * mathImgHeight + paddingHeight,
                  imgWidth * percentWidth,
                  imgHeight * percentHeight
                )
                ctx.restore()
              }
            }
            const numberPadding = paperSize !== 'A4' ? 100 : 80
            ctx.drawImage(
              imgLogoWarning,
              0,
              imgHeight * rows + gapImg + paddingHeight + numberPadding
            )
            resolve(changeDpiDataUrl(c.toDataURL('image/jpeg'), 10))
          }
        })
      }
    },

    async handleAlignImage() {
      this.urlLImage = await this.mathsAlignImage(
        'L',
        'images/export-page/logo-warning-export-l.png',
        87
      )

      this.url2LImage = await this.mathsAlignImage(
        '2L',
        'images/export-page/logo-warning-export-2l.png',
        87
      )

      this.urlA4Image = await this.mathsAlignImage(
        'A4',
        'images/export-page/logo-warning-export-a4.png',
        130
      )
    },

    showPopupConfirmCreateAgainAvatar() {
      this.$refs.createAgainAvatarPopup &&
        this.$refs.createAgainAvatarPopup.show({
          title: this.mappingLabels.resetModalTitle,
          message: this.mappingLabels.resetModalMessage,
          textCancelButton: this.mappingLabels.cancelText,
          textSubmitButton: this.mappingLabels.confirmText,
          changeStyle: true,
        })
    },

    handleSubmitModal() {
      this.$nextTick(() => {
        this.resetData()
        this.$refs.createAgainAvatarPopup.hide()
        this.$router.push({ name: 'select-layout' })
      })
    },

    async handleRenderBgTranparent() {
      const avatar = this.modules.avatars
      let canvasWidth = 350
      let canvasHeight = 350

      for (let item of Object.values(avatar)) {
        const fullSrc = item.format.concat(item.src)
        const srcImgSquare = await fillStyleBackgroundImage(
          canvasWidth,
          canvasHeight,
          fullSrc
        )

        const srcImgCirle = await roundedImageCirle(
          canvasWidth,
          canvasHeight,
          fullSrc
        )
        this.dataAvatar.push({
          labelSquare: '四角形',
          labelCirle: '丸形',
          srcImgSquare: srcImgSquare,
          srcImgCirle: srcImgCirle,
        })
      }
    },
  },

  mounted() {
    this.getFirstImage().then(() => {
      this.handleAlignImage()
    })
    this.handleRenderBgTranparent()
  },
}
</script>

<template>
  <div>
    <s-header>{{ mappingLabels.exportTitle }}</s-header>
    <div class="export-page">
      <div class="export-page_container">
        <div class="wrap-content">
          <div class="export-page_image">
            <div :class="`image-wrap ${getOrientation}`">
              <img :src="getExportImage" alt="label.jpeg" />
            </div>
          </div>
          <p class="export-page_title" v-html="displayTextTitle.titleText"></p>
          <div class="export-page_content">
            <div class="wrap-option">
              <div class="wrap-option_save-image" v-if="dataAvatar.length">
                <s-chatbox class="save-print-title"
                  >アバターを保存する</s-chatbox
                >
                <div class="wrap-img">
                  <template v-for="(item, index) in dataAvatar">
                    <div
                      :key="index"
                      class="img-item"
                      @click="showModalSaveAvatar(item.srcImgCirle, true)"
                    >
                      <div class="img cirle-img">
                        <img
                          v-if="item.srcImgCirle"
                          :src="item.srcImgCirle"
                          :alt="item.labelCirle + 'label'"
                        />
                        <div v-else class="loading"></div>
                      </div>
                      <p class="label">{{ item.labelCirle }}</p>
                    </div>
                    <div
                      :key="`cirle${index}`"
                      class="img-item"
                      @click="showModalSaveAvatar(item.srcImgSquare)"
                    >
                      <div class="img">
                        <img
                          v-if="item.srcImgSquare"
                          :src="item.srcImgSquare"
                          :alt="item.labelSquare + 'label'"
                        />
                        <div v-else class="loading"></div>
                      </div>
                      <p class="label">{{ item.labelSquare }}</p>
                    </div>
                  </template>
                </div>
              </div>
              <div class="save-print-image">
                <s-chatbox class="save-print-title">{{
                  mappingLabels.printTitle
                }}</s-chatbox>
                <div class="wrap-store-print">
                  <p class="sub-title">
                    <x-icon-store :classCustom="'icon-custom'"></x-icon-store
                    >{{ mappingLabels.storeTitle }}
                  </p>
                  <div class="wrap-img wrap-custom">
                    <div
                      class="img-item item-L"
                      @click="showPrintImageModal(urlLImage)"
                    >
                      <div class="img">
                        <img
                          v-if="urlLImage"
                          :src="urlLImage"
                          alt="label_L.jpeg"
                          width="47px"
                        />
                        <div v-else class="loading"></div>
                      </div>
                      <p class="label">L版サイズ</p>
                    </div>
                    <div
                      class="img-item item-2L"
                      @click="showPrintImageModal(url2LImage)"
                    >
                      <div class="img">
                        <img
                          v-if="url2LImage"
                          :src="url2LImage"
                          alt="label_2L.jpeg"
                          width="47px"
                        />
                        <div v-else class="loading"></div>
                      </div>
                      <p class="label">2L版サイズ</p>
                    </div>
                  </div>
                </div>
                <div class="wrap-home-print">
                  <p class="sub-title">
                    <x-icon-home :classCustom="'icon-custom'"></x-icon-home
                    >{{ mappingLabels.homePrintTitle }}
                  </p>
                  <div class="wrap-img wrap-custom">
                    <div
                      class="img-item item-A4"
                      @click="showPrintImageModal(urlA4Image)"
                    >
                      <div class="wrap-img">
                        <div class="img">
                          <img
                            v-if="url2LImage"
                            :src="urlA4Image"
                            alt="label_A4.jpeg"
                            width="96px"
                          />
                          <div v-else class="loading"></div>
                        </div>
                      </div>
                      <p class="label">A4サイズ</p>
                    </div>
                  </div>
                  <div class="wrap-desc">
                    <p>
                      ※印刷する際はプリンターでの詳細設定を「フチなし印刷（全面印刷）」にしてください。「フチなし印刷（全面印刷）」設定ができないプリンターではやや小さめに印刷されてしまいますので予めご了承ください。
                    </p>
                    <p>
                      A4印刷をする場合、プリンターの機種により、印刷されるラベルの大きさが変動することがあります。予めご了承ください。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="social-wrap">
              <div class="social-wrap_title">
                <div>{{ mappingLabels.socialTitle }}</div>
                <div>SNS SHARE</div>
              </div>
              <div class="social-content">
                <ShareNetwork
                  network="twitter"
                  url="https://fun.asahi-gf.co.jp/mintialabel/#/"
                  title="自分だけのオリジナルミンティアラベルを作ろう！作ったラベルは、実物サイズの印刷用データでダウンロードできます。"
                  hashtags="アサヒグループ食品 @asahigf_jpより"
                >
                  <div class="img-social">
                    <img
                      src="@/assets/images/export/twitter-cricle.png"
                      alt="switer"
                    />
                  </div>
                </ShareNetwork>
                <ShareNetwork
                  network="facebook"
                  url="https://fun.asahi-gf.co.jp/mintialabel/#/"
                  title="自分だけのオリジナルミンティアラベルを作ろう！作ったラベルは、実物サイズの印刷用データでダウンロードできます。"
                  hashtags="アサヒグループ食品"
                >
                  <div class="img-social">
                    <img src="@/assets/images/export/fb.png" alt="facebook" />
                  </div>
                </ShareNetwork>
                <ShareNetwork
                  network="line"
                  url="https://fun.asahi-gf.co.jp/mintialabel/#/"
                  title="自分だけのオリジナルミンティアラベルを作ろう！作ったラベルは、実物サイズの印刷用データでダウンロードできます。#アサヒグループ食品 @asahigf_jp より"
                >
                  <div class="img-social">
                    <img
                      src="@/assets/images/export/line-cricle.png"
                      alt="line"
                    />
                  </div>
                </ShareNetwork>
              </div>
              <div class="home-page_button">
                <a
                  href="https://fun.asahi-gf.co.jp/"
                  target="_blank"
                  class="s-button white-blue-btn"
                >
                  <img
                    :src="
                      require('@/assets/images/home-page/top_btn_toasahi.svg')
                    "
                  />へもどる
                </a>
              </div>
            </div>
            <div class="group-button">
              <s-navigate-bar
                @leftClick="$router.push({ name: 'preview' })"
                @rightClick="showPopupConfirmCreateAgainAvatar()"
                >もう一度作る</s-navigate-bar
              >
            </div>
          </div>
        </div>
        <s-modal-save-avatar ref="saveAvatarModal"></s-modal-save-avatar>
        <s-modal-print-image ref="printImageModal"></s-modal-print-image>
        <s-modal-confirm
          ref="createAgainAvatarPopup"
          @submit="handleSubmitModal"
        ></s-modal-confirm>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'export.scss';
</style>
